import { makeStyles } from "@material-ui/core"

import { PLACEHOLDER_COLOR } from "@/components/Messages/MediaMessage/styles"
import { themeColors } from "letalkui"
import { deviceIsMobile } from "@/utils/checkDevice"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	pictureMedia: {
		objectFit: "cover",
		objectPosition: "center",
		width: 56,
		height: 40,
		...ColorUtil.getBackgroundAndContrastColor(PLACEHOLDER_COLOR),
		borderRadius: "12px"
	},
	mediaInfoContainer: {
		minWidth: 0,
		maxWidth: deviceIsMobile() ? "195px" : "200px",
		fontSize: "12px"
	},
	mediaInfoContainerWide: {
		minWidth: 0,
		maxWidth: deviceIsMobile() ? "195px" : "520px",
		fontSize: "12px"
	},
	mediaInfoText: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
		maxWidth: deviceIsMobile() ? "100px" : "170px"
	},
	mediaInfoTextWide: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
		maxWidth: deviceIsMobile() ? "100px" : "440px"
	},
	fileMediaContainer: {
		width: 28,
		height: 40,
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	videoMediaContainer: {
		width: 56,
		height: 40,
		...ColorUtil.getBackgroundAndContrastColor(PLACEHOLDER_COLOR)
	},
	mediaBlock: {
		padding: "8px",
		borderRadius: "12px",
		flex: "0 1 auto",
		minHeight: "64px"
	},
	mediaBlockOk: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.system.gray[50]),
		border: "1px solid",
		borderColor: themeColors.colors.system.gray[200]
	},
	mediaBlockWarning: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.warning[50]),
		border: "1px solid",
		borderColor: themeColors.colors.warning[500]
	},
	mediaBlockBlocked: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.error[50]),
		border: "1px solid",
		borderColor: themeColors.colors.error[400]
	},
	mediaBlockContainer: {
		display: "flex",
		flexWrap: "wrap",
		gap: "4px"
	},
	audioMediaContainer: {
		width: "220px",
		height: "40px",
		overflow: "hidden",
		"& audio": {
			width: "100%",
			height: "100%"
		}
	},
	mediaWarningText: {
		color: themeColors.colors.warning[600],
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden"
	},
	mediaErrorText: {
		color: themeColors.colors.error[600],
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden"
	},
	mediaSizeText: {
		whiteSpace: "break-spaces",
		fontWeight: "bold"
	}
}))

export default useStyles
